import {
  ContextToolbar,
  PanelActions,
  PanelBehaviors,
  PanelPermissions,
  PanelProperties,
  TabsPanel,
  useTraversal,
} from '@guillotinaweb/react-gmi'
import React from 'react'
import { HomeItems } from './home_items'

export function HomePathView(props) {
  const ctx = useTraversal()

  const tabs = {
    Items: HomeItems,
    Properties: PanelProperties,
    Permissions: PanelPermissions,
    Behaviors: PanelBehaviors,
    Actions: PanelActions,
  }
  const tabsPermissions = {
    Items: 'guillotina.ViewContent',
    Properties: 'guillotina.ModifyContent',
    Permissions: 'guillotina.SeePermissions',
    Behaviors: 'guillotina.ModifyContent',
    Actions: 'guillotina.ModifyContent',
  }

  const calculated = ctx.filterTabs(tabs, tabsPermissions)
  return (
    <TabsPanel
      tabs={calculated}
      currentTab="Items"
      editableTabs={[]}
      rightToolbar={<ContextToolbar {...props} />}
      {...props}
    />
  )
}
